import { NoopScrollStrategy } from "@angular/cdk/overlay";

export class TemplateViewModel {
  public TemplateId: number;
  public TemplateName: string;
}

export class GenericIdName {
  public Id: number;
  public Name: string;
  public Symbol?: string | null;
}

export class observationListVM {
  public Id: number;
  public Name: string;
  public CrackSeverityList: boolean;
  public CrackObsList: boolean;
}

export class ImplementTypeVM {
  public Id: number;
  public Name: string;
  public ImplementTypeId: number

}

export class EQUIPMENTVM {
  public euipmentID: number
  public serialNO: string
  public get_auto: number
  // public  crackcount:number
  public numberofcracks: number
  public crackLenth: number
  public AvgCrackLength: number
  public fixedCrack: number


}
export class GenericIdNameVMforEQUIPMENT {
  public Id: number;
  public Name: string;
  public Equipment: EQUIPMENTVM[]
  public isPrint: boolean

}

export class ImplementsAndModelsVM {
  public ImplementTypeId: number;
  public ModelId: number;
  public ImpementId: string;
  public ImpTypeName: string
  public ModelName: string
  public Capacity: boolean
  public GETType: boolean
  public BCMSetup: boolean
  public TonSetup: boolean
  public GETTypeName: string
  public ReportId:number
}

export class ImpTypeOptionalFields {
  public ImplementTypeId: number;
  public Capacity: boolean
  public GETType: boolean
  public BCMSetup: boolean
  public TonSetup: boolean

  public GETTypeId: number;
}

export class AssetReportStyleUpdate {
  public ImplementId: number;
 
  public ReportId: number;
}

export class FormCatListVMSafety {
  public Id: number;
  public Name: string;
  public Days: number;

}
export class ColourScheme {
  public Id: number;
  public Name: string;
}
export class DealerGroupV {
  public Id: number;
  public Name: string;
}

export class DealerGroupBrandingV {
  public Id: number;
  public styleId: number;
  public Logo: string;
}
export class getMethodSuccessResponse {
  public status: boolean;
  public message: string;
}

export class FECRUserInfo {
  public Id: number;
  public Name: string;
  public Email: string;
  public Roles: string;
}
//GET-423
export class GenericIdNameBudgetHours {
  public Id: number;
  public Name: string;
  public Budget_Hours: number;
  public IsTemplate: boolean;
  public SetupDate:string;
}
export class ResultGetModelDiffMessage {
  public match: boolean
  public modelid_source: string
  public modelid_dest: string
  public smu?: number
}
export class saveNewImplementTypeVM {
  public customerId: number;
  public NewimplementType: string;
}

export class ImplementMakeModelVM {
  public ImplementId: number;
  public ImplementTypeId: number;
  public Name: string;
}
export class MakeListVm {
  public Id: number;
  public Name: string;
  public hide: boolean = false;
}

export class ImplementDetails {
  public Id: number;
  public Make: number;
  public ImplementType: number;
  public SerialNo: string;
  public SetupDate: string;
  public ImplementHoursAtSetup: number;
  public EquipmentSMUAtSetup: number;
  public Hours: number;
  public Bcm: number;
  public Ton: number;
  public purchaseCost: number;
  public additional_serial_num: string;
  public IsTemplate: boolean;
  public BucketCapacity: number;
  public GETType: number;
  public JobsiteId: number;
  public CustomerId: number;
  public IsequipmentOrInventory: number;
  public EQId: number;
  public ImpModelId: number
  public AssetType: number
  public FaimlyId: number
  public CopyFromId: number;
}

export class ComponentVM {
  public Id: number = 0;
  public SchematicName: string = "";
  public SchematicId: number = 0;
  public Name: string = "";
  public MakeId: number = 0;
  public PartNo: string = "";
  public Selected: boolean = false;
  public IsNew: boolean = false;
  public SortOrder: number = 0;
  public CompTypeId: number = 0;
  public IsCritical: boolean;
  public CompBudgetLife: number;
  public isGETCritical: boolean;
  public ActionId: number;
  public cost: number;
  public comment: string;
  public selectComp: boolean = false;
  public ActionSucess: number;
  public Error: string;
  public ActionMinDate: Date;
  public hasObPoint: boolean;
  public ColorCodeID: number
  public MaxCrackLength: number
  public UOM: number;
  public severityType: number;
  public LabourHrs: number
  public LabourCost: number
  public PartCost: number
  public MiscCost: number
  public CusPartNo: string = "";
  public CompTypeSort: number = 1;
  public MakeName: string;
  public Planned: boolean;
  public NoOfCoorinates: number = null;
  public NoOfLocations: number = null;
}

export class MeasurementPointDetails {
  public Id: number;
  public Name: string;
  public Make: number;
  public ObservationListId: number;
  public InitialLength: number;
  public WornLength: number;
  public PartNo: string;
}

export class ObservationPointDetails {
  public Id: number;
  public Name: string;
  public ObservationPointType: number;
  public ObservationListIds: number[];
  public ObservationListId: number;
  public NumberOfReadings: number;
  public LimitNew: number;
  public LimitScrap: number;
  public ComponentName: string;
  public ComponentMake: number;
  public ComponentPartNo: string;
  public ComponentId: number;
  public Selected: boolean = false;
  public Active: boolean;
  public QuestionImage: string;
  public QuestionImagePath: string;
  public IsNewImage: boolean;
  public QName: string;
  public QDesc: string;
  public LimitRange: number;
  public Measurement: number;
  public InspectionDate: string
  public SortOrder: number
  //public SchmeticName :string;
  public InspectionTypeID: number
  public IsAnswer: boolean;
  public IsImage: boolean;

  public Xcoord: number;
  public Ycoord: number;
  public EndXcoord: number;
  public EndYcoord: number;
  public ComponentType: string;
  public ComponentTypeId: number;
  public ComponentTypeSortOrder: number;
  public CrackSeverityListId: number;
}

export class SaveImplementImageParams {
  public GETAuto: number;
  public ImageData: string;
}
export class SaveQuestionImageParams {
  public ObservationPointId: number;
  public ImageData: string;
}

export class SchematicDataVM {
  public Id: number;
  public Data: string;
  public ObservationPoints: ObservationPointVM[];
  public ImageName: string;
  public IsNewImage: boolean;
  public SortOrder: number;
  public OBSCount: number;
  public InactiveOBSCount: number;
  public ComponentTypeIds: string;
  public IsHidden: boolean;
}

export class SchematicDataVMEdit {
  public Id: number;
  public Data: string;
  public ObservationPoints: ObservationPointVMEdit[];
  public ImageName: string;
  public IsNewImage: boolean;
}
export class SchematicUploadParams {
  public ImageName: string;
  public ImageData: string;
  public IsNewImage: boolean;
  public SortOrder: number;
  public Id: number;
}
export class SchematicImagesVM {
  public SchematicImageList: SchematicUploadParams[];
  public SchematicsToRemove: number[];
  public ImplementID: number;
}

export class ObservationPointVM {
  public Id: number;
  public Name: string;
  public PositionX: number;
  public PositionY: number;
  public WornPct: number;
  public InspectionDate: string;
  public SelectedObs: boolean = false;
  public IsNew: boolean = false;
  public EndPositionX: number;
  public EndPositionY: number;
  public IsCrackFixed: boolean;
  public ObPointTypeId: number;
  public CrackStatusId: number;
  public ColorCode: string;
  public CrackStatus?: string;
  public Currentlength?: string;
  public CrackSeverity?: string;
}
export class ObservationPointVMEdit {
  public Id: number;
  public Name: string;
  public PositionX: number;
  public PositionY: number;
  public WornPct: number;
  public InspectionDate: string;
  public PositionXEnd: number;
  public PositionYEnd: number;
  public isCrackFixed: boolean
  public ObservationType: string
  public IsNew: boolean
}
export class ApplySelectionData {
  public IsMP: boolean;
  public Id: number;
  public Category: string;
  public Val: number;
}

export class SaveImplementDetailParams {
  public Details: ImplementDetails;
  public EquipmentId: number;
  public JobsiteId: number;
}

export class SaveMeasurementPointParams {
  public GetAuto: number;
  public MeasurementPoints: MeasurementPointDetails[];
}

export class SaveObservationPointParams {
  public GetAuto: number;
  public ObservationPoints: ObservationPointDetails[];
}

export class SaveComponentParams {
  public ImplementId: number;
  public Components: ComponentVM[];
}

export class SaveModeltParams {
  public ImplementId: number;
  public ModelList: number[];
  public Get_auto: number;
}

export class ValidationErrorStatus {
  public Status: boolean;
  public Message: string;
}

export class GETGenericIdName {
  public Id: number;
  public Name: string;
  public ImplementTypeId: number;
  public EquipmentId: number;
}

export class GenericIdNameImplementType {
  public Id: number;
  public Name: string;
  public EquipmentId: number;
  public IsExpand: boolean;
  public Components: ComponentDetailsDashboard[];
  public WorstWorn: number;
  public HasComponents: boolean;
  public ObsCount: number;
  public CrackCount: number;
  public ImplementId: number;

}

export class ComponentDetailsDashboard {
  public ComponentTypeId: number;
  public ComponentId: number;
  public CompName: string;
  public CompTypeName: string;

  public Worn: number;
  public CMU: number;
  public Residual: number;

  public Projected: number;
  public ReplaceDate: Date;
  public LastInspectionDate: Date;
  public Avg: number;
}

export class WSREFrameComponentDocumnetVM {
  public WSREId: number;
  public ComponentId: number;
  public FileData: string;
}

export class AttachmentsVM {
  public Id: number;
  public Data: string
  public extention: string
  public docInfo: string
  public isNew: boolean
  public FileName: string
}

export class ImplementInspectionAttachmentsVM {
  public Id: number;
  public InspectionId: number
  public CreateDate: Date
  public username: string
  public DocTypeId: number;
  public NoOfDocs: number;
  public Comment: string;
  public Attachments: AttachmentsVM[];
  public IncludeInReport: boolean;
}


export class GETCrackSchematicVM {

  public implementID: number[]
  public EquipmentID: number[]

}


export class DFIInspectionReportVM {
  public Id: number
  public FormUploadID: number
  public CategoryId: number
  public CategoryName: string
  public GroupOrder: number
  public IncludeInBody: boolean
  public IncludeInReport: boolean
}


export class ReportStyles {
  public ReportId: number;
  public ReportName: string;
}

export class SetupImplementPageConstants {
  // Title
  public PAGE_TITLE: string = 'New Implement';
  public PAGE_TITLE_MODIFY: string = "Modify Asset"

  // Sub-title
  //public PAGE_SUBTITLE: string = 'An implement is the part of your machine that has Ground Engaging Tool (GET) components on it. Here you are able to register a new implement, specify the component on it, and select the equipment this implement is on.';
  public PAGE_SUBTITLE: string = '';

  // Thumbnail size
  public THUMBNAIL_WIDTH: number = 180.0;
  public THUMBNAIL_HEIGHT: number = 135.0;

  // Defines for radio button group to 'Setup new implement' or 'Modify existing implement'.
  public IMPLEMENT_SETUP_NEW: string = "1";
  public IMPLEMENT_SETUP_EXISTING: string = "2";

  // Defines for radio button group to setup 'On Equipment' or 'In Inventory'.
  public SETUP_ON_EQUIPMENT: string = "1";
  public SETUP_IN_INVENTORY: string = "2";

  // Defines for measurement point and observation point column names.
  public COL_MAKE: string = "Make";
  public COL_OBSERVATION_LIST: string = "ObservationList";
  public COL_INITIAL_LENGTH: string = "LimitNew";
  public COL_WORN_LENGTH: string = "LimitScrap";
  public COL_PART_NO: string = "PartNo";
  public COL_NUM_READINGS: string = "NumberOfReadings";
  public COL_OP_TYPE: string = "ObservationPointType";
  public COL_OP_NAME: string = "ObservationPointName";
  public COL_OP_Q_NAME: string = "ObservationPointQName";
  public COL_OP_Q_DESC: string = "ObservationPointQDesc";
  public COL_OP_LIMITRANGE: string = "LimitRange";
  public COL_OP_MEASUREMENT: string = "Measurement";



  // Dialogs
  public INFO_IMPLEMENT_DELETED: string = "Implement deleted.";

  // Limit number of readings
  public MIN_NUM_READINGS: number = 0;
  public MAX_NUM_READINGS: number = 5;
}

export class SetupImplementErrorCodes {
  public ERROR_CHANGING_IMPLEMENT_TYPE: string = "Error changing the implement type! Please select an attached implement from the list above.";
  public ERROR_INVALID_IMPLEMENT_TYPE: string = "Please select a valid implement type.";
  public ERROR_MISSING_FIELDS: string = "Please enter all fields to continue.";
  public ERROR_SELECT_IMPLEMENT: string = "Please select an attached implement before proceeding!";
  public ERROR_SERIALNO_VALIDATION_FAILED: string = "That serial number is unavailable. Please enter a different one.";
  public ERROR_SAVING_SETUP_EVENT: string = "Failed to save implement setup event.";
  public ERROR_SAVING_MP: string = "Failed to save components!";
  public ERROR_SAVING_OP: string = "Failed to save observation points!";
  public ERROR_SAVING_CHANGES: string = "Failed to save changes.";
  public ERROR_VALIDATION_FAILED = "Validation failed for one or more items! Please fix the errors before continuing.";
  public ERROR_VALIDATION_SETUP_DATE = "Implement setup date is invalid.";
  public ERROR_VALIDATION_EQUIPMENT_SMU = "Equipment SMU at setup is invalid.";
  public ERROR_VALIDATION_IMPLEMENT_LIFE = "Implement life at setup is invalid.";
  public ERROR_COMPONENT_NAME_MISSING: string = "Please enter a name for all components.";
  public ERROR_COMPONENT_NAME_MISSING_2: string = "Please enter a name for this new component.";
  public ERROR_UNSAVED_CHANGES_PREVIOUS_STEP: string = "You may have unsaved changes on this page! Please press 'Next' to save changes, or press the 'Back' button again to go to the previous step.";
  public ERROR_UNSAVED_CHANGES_PREVIOUS_STEP_2: string = "You may have unsaved changes on this page! Please press 'Save & Setup Implement' to save changes, or press the 'Back' button again to go to the previous step.";
  public ERROR_UNSAVED_CHANGES_PREVIOUS_STEP_3: string = "You may have unsaved changes on this page! Please press 'Next' to save changes, or press the 'Back' button again to go to the previous step.";



  public ERROR_COMPONENT_PART_MISSING: string = "Please enter a part for all components.";
  public ERROR_COMPONENT_MAKE_MISSING: string = "Please select a make for all components.";
  public ERROR_COMPONENT_TYPE_MISSING: string = "Please select a type for all components.";
  public ERROR_COMPONENT_TYPE_SCHEMATIC_MAP_MISSING: string = "Warning: Component type(s) not linked to schematic.";
  public ERROR_COMPONENT_SCHEMATIC_MISSING: string = "Please select schematic for this new component.";


  public ERROR_COMPONENT_PART_MISSING_2: string = "Please enter a part for this new component.";
  public ERROR_COMPONENT_MAKE_MISSING_2: string = "Please select a make for this new component.";
  public ERROR_COMPONENT_TYPE_MISSING_2: string = "Please select/add a type for this new component.";


  public ERROR_SAVING_EXISIING_IMPLEMENT: string = "Failed to copy to exisiting implement.";

}

export class UpdateComponentVM {
  public ObservationPointId: number;
  public ComponentId: number;
}

export class UpdateObsPointVM {
  public SetValue: string;
  public ObservationPointId: number;
}

export class UpdateQuestion {
  obsPointId: number;
  obsQuestion: string;
  obsQuestionImg: string;
}

export class DeleteQuestion {
  obsPointId: number;
  deleteInstruction: boolean;
}


export interface Locations{
  Id: number;
  ComponentId: number;
  LocationName: string;
  ComponentGroupNumber: number;
}

export interface Points {
  x: number;
  y: number;
}

export interface DrawShape {
  id: number;
  componentId: number;
  componentGroupNumber: number;
  points: Points[];
  locations: Locations[];
  newLocation: string;
}

export interface ResponseMessage {
  success: boolean;
  message: string;
}

export interface GenericIdNameVM {
  id: number;
  name: string;
}

export interface ApiResponse<T> {
  Data: T;
  Status: number;
  Message: string;
}

export class CrackStatusVM{
  public Id: number;
	public CrackStatus: string;
	public Active: boolean;
	public ColorCode: string;
	public SortOrder: number;
  public isSelected?: boolean;
}

export interface InspectorDto {
  data: Inspector[];
  status: number;
  message: string;
}

export interface Inspector{
  Id: number;
  Name: string;
}

export interface SchematicType {
  SchematicAuto: number;
  SchematicName: string;
  GETComponentTypeId: number;
}


